import React, { useContext } from "react";
import { VirtualizedList, View, ScrollView } from "react-native";

import { hasItems } from "../../../../helpers/utils";
import ReflectionItem from "./ReflectionItem";
import ReflectionContext from "../ReflectionContext";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";

export default function ReflectionList(props) {
  const {
    reflections = [],
    controller = null,
    hasChart = false,
    reverse = true,
    source = null,
    expandAll = false,
  } = props;
  const { showReflectionTutorials, tutorialStep } =
    useContext(ReflectionContext) || {};

  const itemCount = (data) => (hasItems(data) ? data.length : 0);
  const getItemData = (data, index) => data[index];
  const keyExtractor = (item) => item.item_id;
  const renderItem = ({ item, index }) => (
    <ReflectionItem
      item={item}
      key={item.item_id}
      index={index}
      controller={controller}
      hasChart={hasChart}
      reverse={reverse}
      isLast={index === reflections.length - 1}
      source={source}
      expandAll={expandAll}
    />
  );

  const itemsToRender = 20;
  const renderPerBatch = 20;
  const windowSize = 31;

  return (
    <ScrollView
      scrollEnabled={!(showReflectionTutorials && tutorialStep == 1)}
      style={[
        appStyles.scrollView,
        { position: "relative", backgroundColor: AppTheme.containerBg },
      ]}
      contentContainerStyle={appStyles.scrollViewContent}
    >
      {props.children ? <>{props.children}</> : null}

      {showReflectionTutorials && tutorialStep == 1 ? (
        <View style={appStyles.overlay} />
      ) : null}

      <VirtualizedList
        data={reflections}
        initialNumToRender={itemsToRender}
        maxToRenderPerBatch={renderPerBatch}
        windowSize={windowSize}
        removeClippedSubviews={false}
        getItemCount={itemCount}
        getItem={getItemData}
        keyExtractor={keyExtractor}
        renderItem={renderItem}
        contentContainerStyle={appStyles.scrollViewContent}
      />
    </ScrollView>
  );
}
